import mainServerClient from "../http/mainServerClient";

/** 更新电子面单余额预警阈值 */
export function updateEwaybillQUantityThreshold(ewaybillQuantityThreshold: number) {
    return mainServerClient.post("/company_setting/update_ewaybill_quantity_threshold", { ewaybillQuantityThreshold });
}

export interface CompanySettingDTO {
    /**
     * 电子面单余额预警阈值。
     */
    ewaybillQuantityThreshold?: number;
    /**
     * 订单信息复制设置，具体格式由前端回传
     * 订单列表——其他操作——复制订单信息
     */
    orderInfoCopySetting?: string;
}

/** 获取当前登录用户对应Company的设置 */
export function getCompanySetting() {
    return mainServerClient.get<CompanySettingDTO>("/company_setting/get");
}

export enum QuickTimeSelectConfigMode {
    HOURS_AGO = "HOURS_AGO",
    RECENT_HOURS = "RECENT_HOURS",
    RECENT_DAYS = "RECENT_DAYS",
}

export interface QuickTimeSelectConfig {
    /**
     * 创建时间戳（用于淘汰最早的自定义配置）
     */
    createTime?: number;
    /**
     * 配置 ID（用于排序和去重标识）
     */
    id?: string;
    /**
     * 是否为默认配置（默认配置不占用 10 个限额，不会被删除）
     */
    isDefault?: boolean;
    /**
     * 模式类型
     */
    mode?: QuickTimeSelectConfigMode;
    /**
     * 排序序号（用于前端拖动排序，数字越小越靠前）
     */
    sortOrder?: number;
    /**
     * 时间数值（X），必须大于 0
     */
    value?: number;
}

export function getQuickTimeSelectConfigs() {
    return mainServerClient.get<QuickTimeSelectConfig[]>("/company_setting/get_quick_time_select_configs");
}

export function addQuickTimeSelectConfig(mode: QuickTimeSelectConfigMode, value: number) {
    return mainServerClient.post<QuickTimeSelectConfig[]>("/company_setting/add_quick_time_select_config", {
        mode,
        value,
    });
}

export function deleteQuickTimeSelectConfig(configId: string) {
    return mainServerClient.post<QuickTimeSelectConfig[]>("/company_setting/delete_quick_time_select_config", {
        configId,
    });
}

export function updateQuickTimeSelectConfigSort(configIds: string[]) {
    return mainServerClient.post<QuickTimeSelectConfig[]>("/company_setting/update_quick_time_select_config_sort", {
        configIds,
    });
}
